import Inputmask from 'inputmask';

export default new class PhoneMask {
  constructor() {
    this.im_telephone = new Inputmask({
      mask: '(099) 999-99-99',
      clearIncomplete: true,
      showMaskOnHover: false,
    });

    this.im_code = new Inputmask({
      mask: '99-99',
      clearIncomplete: true,
      showMaskOnHover: false,
    });

    this.init();
  }

  init() {
    this.im_telephone.mask(document.querySelectorAll('input[name="telephone"]'));
    this.im_code.mask(document.querySelectorAll('input[name="confirmation_code"]'));
  }
}();
